import { useTranslation } from 'react-i18next'
import styles from './SpotListTabs.module.css'

type Props = {
  tabs: string[]
  activeTab?: string
  onChange?: (tab: string) => void
  className?: string
}

export function SpotListTabs({ tabs, activeTab, onChange, className }: Props) {
  const { t } = useTranslation()
  const active = activeTab ?? tabs[0]

  return (
    <div
      className={`${styles.container} ${className ?? ''}`}
      role="tablist"
      aria-label={t('spot.filter_aria', 'スポット絞り込み')}
    >
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={active === tab}
          className={`${styles.tab} ${active === tab ? styles.active : ''}`}
          onClick={() => onChange?.(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  )
}
